import { DisplayNameDictionary } from '@common/types';
import { SPACE_REGEX } from 'mbs-ui-kit/utils/constants';

export function getTermKey(obj: DisplayNameDictionary, term: string): string {
  return Object.entries(obj)
    .filter(([, value]) => value.displayName.replace(SPACE_REGEX, ' ').toLowerCase() === term.replace(SPACE_REGEX, ' ').toLowerCase())
    .map((item) => (item.length > 0 ? Object.values(item)[0] : item))
    .join();
}
